<!--
 * @FileDescription:
 * @Author: 刘凯
 * @Date: 2022-02-25 13:50:39
 * @LastEditors: 刘凯
 * @LastEditTime: 2022-02-25 14:05:25
-->

<script>
import { getFilePrefix } from '../utils';

export default {
  props: {
    showDelete: {
      type: Boolean,
      default: false
    },
    file: {
      type: Object,
      default: () => ({})
    },
    imageHeight: {
      type: String,
      default: '106px'
    },
    fileNameHidden: Boolean,
    fileStatusHidden: Boolean,
    viewBtnIsShow: {
      type: Boolean,
      default: true
    },
    downloadBtnIsShow: {
      type: Boolean,
      default: true
    },
    joinKnglibBtnIsShow: {
      type: Boolean,
      default: true
    },
    isManagement: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      curUrl: {}
    };
  },
  computed: {
    isDefaultIconUsed() {
      const { viewUrl, fileType, status } = this.file;
      const checkList = [
        fileType !== 'audio' && !viewUrl,
        fileType === 'audio' && status !== 1 // 音频转码没有成功
      ];
      return checkList.some(val => val);
    },
    tooltip() {
      return this.isManagement ? 'yxt-tooltip' : 'yxtf-tooltip';
    }
  },
  methods: {
    getFilePrefix,
    getFilteredImg(url) {
      if (url && !!~url.indexOf('picobd') && !~url.indexOf('.gif')) {
        return `${url}?x-bce-process=image/quality,q_10`; // https://portal.cloud.geely.com/doc/BOS/s/Ukbisw1em-GEELY_V310
      } else {
        return url;
      }
    }
  }
};
</script>
